<div class="insurance-premium-summary-component">
  @if (summary) {
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="mat-h2">Summary</div>
        </div>
      </div>
      @if (summary.monthlyRepayment) {
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <mat-form-field>
              <mat-label>Monthly repayments</mat-label>
              <input matInput class="ml-4" type="input" readonly name="monthlyRepayment" [ngModel]="summary.monthlyRepayment">
              <span class="mdi mdi-currency-usd" matPrefix></span>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Application ID</div>
            <div body>{{summary.applicationId}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation</div>
            <div body>{{summary.organisation?.organisationName}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Introducer Contact</div>
            <div body>{{summary.brokerContact?.FirstName}} {{summary.brokerContact?.LastName}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ABN</div>
            <div body>{{summary.abn}}</div>
          </cell>
        </div>
        @if (summary.organisationType?.name=='Company') {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>ACN</div>
              <div body>{{summary.acn}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        @if (summary.organisationType) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Organisation type</div>
              <div body>{{summary.organisationType.name}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Revenue</div>
            <div body><span class="mdi mdi-currency-usd"></span>{{summary.annualRevenue}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-4 col-md-12">
          <cell>
            <div label>Primary industry</div>
            <div body>{{summary.primaryIndustry?.title}}</div>
          </cell>
        </div>
        @if (summary.industrySector) {
          <div class="col-lg-4 col-md-12">
            <cell>
              <div label>Industry sector</div>
              <div body>{{summary.industrySector.title}}</div>
            </cell>
          </div>
        }
        @if (summary.subdivisionIndustrySector) {
          <div class="col-lg-4 col-md-12">
            <cell>
              <div label>Industry class</div>
              <div body>{{summary.subdivisionIndustrySector.title}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Principal place of business address</div>
            <div body>{{summary.primaryBusinessAddress?.address}}</div>
          </cell>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Registered business address</div>
            <div body>{{summary.registeredBusinessAddress?.address}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      @if (summary.policies && summary.policies.policies && summary.policies.policies.length) {
        @for (policy of summary.policies.policies; track policy; let index = $index) {
          <div class="row">
            <div class="col-12 mt-3">
              <div class="application-subsection-title">Policy {{index + 1}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <cell>
                <div label>Type of cover</div>
                <div body>{{policy.coverType?.ProductName}}</div>
              </cell>
            </div>
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Policy number</div>
                <div body>{{policy.policyNumber}}</div>
              </cell>
            </div>
          </div>
          <mat-divider [inset]="true"></mat-divider>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <cell>
                <div label>Insurer</div>
                <div body>{{policy.insurer}}</div>
              </cell>
            </div>
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Inception date</div>
                <div body>{{displayableDate(policy.inceptionDate)}}</div>
              </cell>
            </div>
          </div>
          <mat-divider [inset]="true"></mat-divider>
          <div class="row">
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Expiry date</div>
                <div body>{{displayableDate(policy.expiryDate)}}</div>
              </cell>
            </div>
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Premium amount</div>
                <div body>{{policy.premiumAmount}}</div>
              </cell>
            </div>
          </div>
          <mat-divider [inset]="true"></mat-divider>
        }
      }
      @if (summary.loanPurpose) {
        <loan-purpose-summary [needPadding]='false' [loanPurpose]="summary.loanPurpose"></loan-purpose-summary>
        <mat-divider [inset]="true"></mat-divider>
      }
      @if (summary.authorisedSignatories && summary.authorisedSignatories.length) {
        @for (signatory of summary.authorisedSignatories; track signatory; let index = $index) {
          <div class="row">
            <div class="col-12 mt-3">
              <div class="application-subsection-title">Authorised signatory {{index + 1}}</div>
            </div>
          </div>
          <div class="row">
            @if (signatory.title) {
              <div class="col-lg-3 col-md-12">
                <cell>
                  <div label>Title</div>
                  <div body>{{signatory.title.name}}</div>
                </cell>
              </div>
            }
            @if (signatory.firstName) {
              <div class="col-lg-3 col-md-12">
                <cell>
                  <div label>First name</div>
                  <div body><p [innerHTML]="signatory.firstName | ellipsis:10"></p></div>
                </cell>
              </div>
            }
            @if (signatory.lastName) {
              <div class="col-lg-3 col-md-12">
                <cell>
                  <div label>Last name</div>
                  <div body><p [innerHTML]="signatory.lastName | ellipsis:10"></p></div>
                </cell>
              </div>
            }
          </div>
          <mat-divider [inset]="true"></mat-divider>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <cell>
                <div label>Role</div>
                <div body>{{signatory.role?.name}}</div>
              </cell>
            </div>
          </div>
          <mat-divider [inset]="true"></mat-divider>
          <div class="row">
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Email</div>
                <div body>{{signatory.email}}</div>
              </cell>
            </div>
            <div class="col-lg-3 col-md-12">
              <cell>
                <div label>Mobile Number</div>
                <div body>{{signatory.mobile}}</div>
              </cell>
            </div>
          </div>
          <mat-divider [inset]="true"></mat-divider>
        }
      }
      <!-- CONTACTS -->
      <div class="mt-3">
        <contacts-summary [contacts]="summary.contacts"></contacts-summary>
      </div>
      <!-- ENTITIES -->
      <div class="mt-3">
        <entities-summary [entities]="_entities"></entities-summary>
      </div>
      @if (summary.applicationNotes) {
        <div class="row">
          <div class="col-12 mt-3">
            <div class="application-subsection-title">Application notes</div>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-6">
          {{summary.applicationNotes}}
        </div>
      </div>
    </div>
  }
</div>
